import { notification } from "antd";
import { NotificationInstance } from "antd/es/notification/interface";
import { ReactNode, createContext, useContext } from "react";

const NotificationContext = createContext<NotificationInstance | null>(null);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [api, contextHolder] = notification.useNotification();

  return (
    <NotificationContext.Provider value={api}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}
